<template>
  <div>
    <div class="header-container">
      <div class="top-menu-left">
        <el-select v-model="companyId" placeholder="请选择"
          style="width: 450px;"
          :popper-append-to-body="false" @change="companyChg">
          <el-option
            v-for="item in companyList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="header-left">
        <img class="header-img" src="@/assets/images/header-left.png"/>
      </div>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
        style="pointer-events: none;">
          <defs>
            <linearGradient id="orange_red" x1="100%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style="stop-color: #9FF9FF;"/>
            <stop offset="100%" style="stop-color: #2362FF;"/>
            </linearGradient>
          </defs>
          <text
            style="text-anchor: middle; dominant-baseline: middle;
            fill: url(#orange_red); font-size:26px; font-weight:400;
            pointer-events: none;"
            x="50%" y="65%">
            项目管理大数据指挥中心
          </text>
        </svg>
      <div class="header-right">
        <img class="header-img" src="@/assets/images/header-right.png"/>
      </div>
      <div class="top-menu-right" v-if="userName !== ''">
        <div>
          <el-link :underline="false" class="top-menu-text">{{userName}}</el-link>
        </div>
        <div>&nbsp;&nbsp;&nbsp;&nbsp;</div>
        <div @click="doLogout">
          <el-link :underline="false" class="top-menu-text">退出</el-link>
        </div>
      </div>
    </div>
    <div class="header-container-sub">
      <div class="header-left">
        <img class="header-img" src="@/assets/images/header-left-sub.png"/>
      </div>
      <div class="header-text-sub">
        <div>{{ this.$moment(dataInfo.now).format('YYYY年M月D日') }}</div>
      </div>
      <div class="header-right">
        <img class="header-img" src="@/assets/images/header-right-sub.png"/>
      </div>
    </div>
  </div>
</template>
<script>
import globalConf from '@/config/globalConf';
import { USER_COMPANY_LIST } from '@/api/bigdata';

export default {
  name: 'AppHeader',
  data() {
    return {
      dialogUserVisible: false,
      dialogPassVisible: false,
      dataInfo: {},
      companyId: '',
    };
  },
  created() {
    this.getCompanyList();
  },
  computed: {
    userName() {
      return this.$store.getters.getUser.name || this.dataInfo.name;
    },
    companyList() {
      return (this.dataInfo.userCompanyList || [])
        .map(vo => ({ value: vo.companyId, label: vo.name }));
    },
  },
  methods: {
    getCompanyList() {
      this.$axios.jsonGet(USER_COMPANY_LIST).then((result) => {
        if (result.code === 0) {
          this.dataInfo = result.data;
          // 默认取第一个公司
          const [first] = this.dataInfo.userCompanyList;
          if (first) {
            this.companyId = first.companyId;
            this.$store.dispatch('doCompanyChange', first);
          }
        }
      });
    },
    companyChg(val) {
      const company = (this.dataInfo.userCompanyList || [])
        .find(item => item.companyId === val);
      if (company) {
        this.$store.dispatch('doCompanyChange', company);
        this.$router.push({ path: '/bigdata/home' });
      }
    },
    doLogout() {
      this.$confirm('确认退出吗？', '提示', {
        type: 'warning',
        center: true,
      }).then(() => {
        this.$store.dispatch('clearStorage');
        this.$store.dispatch('doLogout').then(() => {
          window.location.href = globalConf.indexPage;
        }).catch(() => {
          this.$store.dispatch('doTimeoutLogout').then(() => {
            window.location.href = globalConf.indexPage;
          });
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/theme/app.scss';

  .header {
    &-container {
      position: relative;
      width: 100%;
      height: 48px;
      display: flex;
      &-sub {
        @extend .header-container;
        padding-top: 12px;
        height: 25px;
      }
    }
    &-left, &-right {
      flex: 1;
    }
    &-img {
      width: 100%;
      height: 100%;
    }
    &-text {
      text-align: center;
      background: linear-gradient(to bottom, $header-text-top-color, $header-text-bottom-color);
      background-clip: text;
      color: transparent;
      font-size:26px;
      font-weight:400;
      display: flex;
      height: 48px;
      justify-content: center;
      align-items: flex-end;
      &-sub {
        position: absolute;
        font-size: 16px;
        line-height: 16px;
        height: 16px;
        color: $header-text-sub-color;
        padding-top: 12px;
        top: 0px;
        left: 50%;
        transform: translate(-50%, 0);
      }
    }
  }

  .top-menu {
    position: absolute;
    height: 100%;
    display: flex;
    font-size: 14px;
    font-weight:400;
    align-items: center;
    justify-content: center;
    &-left {
      @extend .top-menu;
      top: 0px;
      left: 0px;
      padding-left: 1.5rem;
    }
    &-right {
      @extend .top-menu;
      top: 0px;
      right: 0px;
      padding-right: 1.5rem;
    }
    &-text.el-link--default {
      color: $white-color;
    }
  }

  .top-menu-left {
    /deep/ .el-input__inner {
      background: rgba($backgroud-rgba-color, 0.5);
      color: $white-color;
      border-color: rgba($border-rgba-color, 0.5);
    }
    /deep/ i.el-input__icon  {
      color: $icon-color;
    }
    /deep/ .el-select-dropdown {
      background-color: $dropdown-backgroud-color;
      border-color: $dropdown-border-color;
      &__item.selected {
        color: $font-color-focus;
      }
    }
    /deep/ .el-popper[x-placement^="bottom"] .popper__arrow {
      border-bottom-color: $dropdown-border-color;
      &::after{
        border-bottom-color: $dropdown-backgroud-color;
      }
    }
    /deep/ .el-select-dropdown__item {
      color: $font-color;
      &.hover, :hover {
        background-color: $hover-backgroud-color;
      }
     }
  }

  .top-menu-right-dropdown {
    background-color: $dropdown-backgroud-color;
    border-color: $dropdown-border-color;
    color: $white-color;
    padding: 0px 0px;
    margin-bottom: 0px;
    /deep/ div.popper__arrow {
      border-bottom-color: $dropdown-border-color;
      &::after{
        border-bottom-color: $dropdown-backgroud-color;
      }
    }
    /deep/ .el-dropdown-menu__item {
      color: $font-color;
      &--divided {
        margin-top: 0px;
        border-top-color: $dropdown-backgroud-color;
        &::before {
          height: 1px;
          background-color: $dropdown-border-color;
        }
      }
    }
    /deep/ .el-dropdown-menu__item:not(.is-disabled):hover, .el-dropdown-menu__item:focus {
      color: $font-color-focus;
      background-color: $hover-backgroud-color;
      font-weight: bold;
    }
  }

</style>
